// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"203":"language","348":"chat"}[chunkId] + "." + {"203":"9e94d1d4","348":"873ed44f"}[chunkId] + ".js";
};